import React from "react";

import Game from "./pages/Luck77";

const App = () => {
  return <Game />;
};

export default App;
